var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTempo = function SvgTempo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.935 7.691-1.528-1.145V3.773h-1v3.273l1.927 1.445z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.907 1.546a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5m-4.25 5.25a4.25 4.25 0 1 1 8.5 0 4.25 4.25 0 0 1-8.5 0",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.304 12.577a2.104 2.104 0 0 0-2.975 0l-2.048 2.048a1.77 1.77 0 0 0-1.192-.46H7.616a3.96 3.96 0 0 0-2.796 1.158l-2.73 2.73.708.706 2.73-2.729a2.96 2.96 0 0 1 2.088-.865h5.474a.772.772 0 0 1 0 1.544h-3.046v1h3.045a1.772 1.772 0 0 0 1.637-2.453l.169.169 2.141-2.141a1.103 1.103 0 1 1 1.56 1.56L13.07 20.37a.6.6 0 0 1-.426.177H6.047v1h6.597a1.6 1.6 0 0 0 1.134-.47l5.526-5.526a2.104 2.104 0 0 0 0-2.974"
  })));
};
export default SvgTempo;